// in src/Clients.js
import React, { useEffect } from "react";
// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  ReferenceInput,
  BooleanField,
  TextField,
  TextInput,
  DateInput,
  ShowButton,
  EditButton,
  DeleteButton,
  SelectInput,
  ReferenceField,
  AutocompleteInput,
  PasswordInput,
  BooleanInput,
  minLength, email, required, choices,
  useNotify, useRefresh, useRedirect, DateField,
  useDataProvider,
  FunctionField
} from "react-admin";

const ClientFilter = (props) => {
  const dataProvider = useDataProvider();
  useEffect(() => {
    console.log(dataProvider)
  }, [])

  return (
    <Filter {...props}>
      <TextInput label="Buscar correo" source="email" alwaysOn />
      <TextInput label="Nombre Tienda" source="nombreempresa" alwaysOn />
      {/* <TextInput label="Apellido" source="lastname" alwaysOn /> */}
      <ReferenceInput
        label="Plan Actual"
        reference="planes"
        source="id_plan"
        alwaysOn
      >
        <SelectInput optionValue="id" optionText="nombre" placeholder="Elegir plan" alwaysOn />
      </ReferenceInput>
      <SelectInput label="Estado" source="activa" choices={[
        {id: true, name: 'Activas'},
        {id: false, name: 'Desactivadas'}
      ]} alwaysOn />
      <TextInput label="Celular" source="celular" alwaysOn />
    </Filter>
  );
}

const DesactivarButton = (props) => {
  const { record, source } = props;
  const [recordActual, setRecordActual] = React.useState(record);


  const handleActivateStore = () => {
    var status = recordActual.activa;
    if (window.confirm(status ? '¿Está seguro de desactivar esta cuenta?' : '¿Está seguro de activar esta cuenta?')) {
      fetch('https://us-central1-micatalogovirtual-app.cloudfunctions.net/cambiarestadocuenta', {
        body: JSON.stringify({
          id: record.id,
          activa: !status
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST'
      }).then(response => response.json()).then(result => {
        if (!result.success) {
          window.alert('Ha ocurrido un error al desactivar la cuenta. Por favor intentar de nuevo o contactar al soporte');
        }
        setRecordActual({activa: !status});
      })
    }
  }

  return (
    <button style={{padding: 0, borderWidth:0,background:'transparent', cursor: 'pointer'}} onClick={() => { handleActivateStore() }}>
        <BooleanField className="actives" record={{...recordActual,activa:!!recordActual.activa}} source={source} valueLabelTrue="Activa" valueLabelFalse="Desactivada"/>
    </button>
  )
}

export const ClientList = (props) => {

  return (
  <List title="Clientes" {...props} filters={<ClientFilter />}>
    <Datagrid>
    <TextField source="nombreempresa" label="Nombre tienda" />
      {/* <RichTextField source="body" /> */}
      {/* <TextField source="lastname" label="Apellido" /> */}
	  <TextField source="email" />
    <DateField source="created" label="Registrado desde" />
    
    <ReferenceField label="Plan actual" source="id_plan" reference="planes" link={(record, reference) => `/${reference}/${record.id}`}>
    <TextField source="nombre" />
      </ReferenceField>
      <TextField source="celular" label="Celular" />
      <FunctionField 
        label="Estado"
        source="activa"
        render={(record, source) => (<>
          <DesactivarButton record={record} source={source} />
        </>)}
      />

      <ReferenceField label="Subdominio" source="id" reference="stores" link={false}>
        <TextField source="tienda" />
      </ReferenceField>

      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false}/>
    </Datagrid>
  </List>
  )
};

const ClientTitle = ({ record }) => {
  return <span>Cliente {record ? `${record.email}` : ''}</span>;
};

export const ClientShow = (props) => (
  <Show title={<ClientTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="Identificador" />
      <TextField source="email" label="Correo Electrónico" />
      <TextField source="moneda" label="Moneda" />
      <TextField source="firstname" label="Nombre" />
      <TextField source="lastname" label="Apellido" />
      <BooleanField source="activa" label="Cuenta activa" />
      <ReferenceField label="Plan actual" source="id_plan" reference="planes" link={(record, reference) => `/${reference}/${record.id}`}>
        <TextField source="nombre" />
      </ReferenceField>
      <DateField source="created" />
    </SimpleShowLayout>
  </Show>
);

export const ClientCreate = (props) => {
  const validatePassword = [minLength(6, 'Este campo debe tener al menos 6 carácteres'), required('Este campo es obligatorio')];
  const validateRequired = [required('Este campo es obligatorio')];
  const validateRequiredAndEmail = [required('Este campo es obligatorio'), email('Correo inválido')];
  const validateMoneda = choices(['cop', 'usd'], 'La moneda debe ser una de las especificadas');
  
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const submit = async (data) => {
    try {
    const resultPrev = await fetch(process.env.REACT_APP_CREATE_USERS_URL, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    const result = await resultPrev.json();
      if (typeof result === 'object' && result.hasOwnProperty('success')) {
        console.log(result)
        if (result.success) {
          notify('El usuario ha sido creado exitosamente');
          redirect('show', 'clients', result.id_cliente);
          refresh();
        } else {
          notify(result.mensaje);
        }
      }
    } catch (error) {
      console.log(error)
      notify('Ha ocurrido un error al crear el usuario. Por favor intentar de nuevo o contactar al soporte');
    }
  }

  return (
    <SimpleForm onSubmit={submit} id="cliente-create-form">
      <TextInput type="email" validate={validateRequiredAndEmail} style={{width:'100%'}} source="email" label="Correo Electrónico" />
      <PasswordInput validate={validatePassword} source="password" style={{width:'100%'}} label="Contraseña" />
      <AutocompleteInput style={{width:'100%'}} validate={validateMoneda} defaultValue="cop" source="moneda" label="Moneda" choices={[
        {value: 'cop', label: 'COP'},
        {value: 'usd', label: 'USD'}
      ]} optionText="label" optionValue="value" />
      <TextInput validate={validateRequired} type="text" style={{width:'100%'}} source="firstname" label="Nombres" />
      <TextInput validate={validateRequired} type="text" style={{width:'100%'}} source="lastname" label="Apellidos" />
      <BooleanInput defaultValue={true} source="activa" label="Cuenta activa" />
      <ReferenceInput label="Planes" source="id_plan" reference="planes">
        <AutocompleteInput validate={validateRequired} optionValue="id" optionText="nombre" />
      </ReferenceInput>
    </SimpleForm>
  );
}

export const ClientEdit = props => {
  let actualizoPlan = false;
  let actualizoEmail = false;
  let actualizoPassword = false;
  let passwordActual = '';

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = async ({ data }) => {
    if (actualizoPlan) {
      await fetch('https://us-central1-micatalogovirtual-app.cloudfunctions.net/crearFactura', {
         method:'POST',
         headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id_cliente: data.id,
          id_plan: data.id_plan,
          moneda: data.moneda
        })
      })
    }
    const dataToUpdate = {}
    if (actualizoEmail) {
      dataToUpdate.email = data.email;
    }
    if (actualizoPassword) {
      dataToUpdate.password = passwordActual;
    }
    if (Object.keys(dataToUpdate).length) {
      dataToUpdate.id_cliente = data.id;
      await fetch('https://us-central1-micatalogovirtual-app.cloudfunctions.net/actualizarUsuario', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToUpdate)
      });
    }

    notify(`Cliente actualizado correctamente`)
    redirect('/clients');
    refresh();
  };

  const handleUpdate = (value, device) => {
    actualizoPlan = !actualizoPlan;
  }


  const handleChangePassword = (event) => {
    passwordActual = event.target.value;
    if (passwordActual) {
      actualizoPassword = true;
    } else {
      actualizoPassword = false;
    }
  }

  const transform = data => ({
      ...data,
      password: ''
  });

  const validatePassword = [minLength(6)];

  return (
    <Edit onSuccess={onSuccess} undoable={false} transform={transform} title={<ClientTitle />} {...props}>
      <SimpleForm>
      <TextInput style={{width:'100%'}} source="id" label="Identificador" options={{ disabled: true }} />
      <TextInput type="email" style={{width:'100%'}} source="email" onInput={(e) => { actualizoEmail = true;  }} label="Correo Electrónico" />
      <PasswordInput validate={validatePassword} source="password" style={{width:'100%'}} onChange={handleChangePassword} label="Modificar contraseña" />
      <AutocompleteInput style={{width:'100%'}} source="moneda" label="Moneda" choices={[
        {value: 'usd', label: 'USD'},
        {value: 'cop', label: 'COP'}
      ]} optionText="label" optionValue="value" />
      <TextInput type="text" style={{width:'100%'}} source="firstname" label="Nombres" />
      <TextInput type="text" style={{width:'100%'}} source="lastname" label="Apellidos" />
      <BooleanInput source="activa" label="Cuenta activa" />
      <ReferenceInput label="Planes" source="id_plan" reference="planes" onChange={(event, deviceId) => { handleUpdate(event, deviceId); }}>
        <AutocompleteInput optionValue="id" optionText="nombre"  onChange={() => {alert('Hola')}} />
      </ReferenceInput>
      </SimpleForm>
    </Edit>
  )
};
